export default [
    {
        name: "Сервисы",
        children: [
            {
                name: "История поиска",
                icon: "clock-history",
                path: "/query-history"
            }
        ]
    }
];
